import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  main {
    height: 100%;
  }
  
  body {
    background: #EFF2F5;
    width: 100%;
    height: 100%;
  }
  
  div {
    box-sizing: border-box;
  }
  
  ul {
    list-style: none;
    padding: 0;
  }
  
  
  body, h1, h2, h3, h4, h5, h6, p {
    margin: 0;
    font-weight: normal;
    font-family: BarlowRegular,serif;
    color: #212121;
  }
  
  a {
    font-family: BarlowRegular,serif;
    text-decoration: none;
  }
  
  button {
    cursor: pointer;
    outline: none;
    border: none;
    background: none;
  }
  
  input {
    color: #FAFAFA;
    outline: none;
    border: none;
  }
  
  label {
    margin: 0;
  }
   
`

export default GlobalStyle
